import React from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";

const OPTED_OUT_MESSAGE =
  "We have removed secondary insurance information from this claim. Please select 'No' if you would like to add the information back.";

const HAS_INSURANCE_MESSAGE =
  "We've detected that this patient has secondary insurance information on file and have attached it to this claim to help ensure accurate processing and coverage. Would you like to remove this secondary insurance from this claim?";

const NO_INSURANCE_MESSAGE =
  "We’ve detected that this patient has no secondary insurance. If you would like to add secondary insurance to this patient, please navigate to the General Info section of the Patient Profile to insert that information.";

interface Props {
  optOutSecIns: boolean;
  onChange: (value: boolean) => void;
  hasSecondaryInsurance: boolean;
  claimStatus: string;
}

const SecondaryInsurance: React.FC<Props> = ({
  optOutSecIns,
  onChange,
  hasSecondaryInsurance,
  claimStatus,
}) => {
  const secondaryInsuranceMessage = () => {
    if (!hasSecondaryInsurance) return NO_INSURANCE_MESSAGE;
    if (optOutSecIns) return OPTED_OUT_MESSAGE;
    return HAS_INSURANCE_MESSAGE;
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        padding: "20px",
        height: "250px",
      }}
    >
      <Typography
        sx={{
          color: "#707070",
          fontWeight: 700,
          fontSize: "14px",
          lineHeight: "26px",
        }}
      >
        Secondary Insurance
      </Typography>
      <p
        style={{
          color: "#707070",
          fontSize: "12px",
          lineHeight: "16px",
          marginBlockStart: "0px",
          marginBlockEnd: "0px",
          marginBottom: "15px",
          marginTop: "5px",
          fontWeight: 400,
        }}
      >
        {secondaryInsuranceMessage()}
      </p>

      {hasSecondaryInsurance && (
        <FormControl>
          <FormLabel
            style={{
              color: "#A29D9B",
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: 700,
              marginBottom: "10px",
            }}
          >
            Remove Secondary Insurance?
          </FormLabel>
          <RadioGroup
            row
            value={optOutSecIns ? "yes" : "no"}
            onChange={(e) => onChange(e.target.value === "yes")}
            sx={{ display: "flex", columnGap: "10px" }}
          >
            <FormControlLabel
              value="no"
              disabled={
                claimStatus === "submitted" ||
                claimStatus === "pending_submission"
              }
              control={
                <Radio
                  sx={{
                    p: 0,
                    "& .MuiSvgIcon-root": {
                      fontSize: 16,
                      marginRight: "5px",
                    },
                  }}
                />
              }
              label="No"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  color: "#1E1E1E",
                },
                marginLeft: "0px",
              }}
            />

            <FormControlLabel
              value="yes"
              disabled={
                claimStatus === "submitted" ||
                claimStatus === "pending_submission"
              }
              control={
                <Radio
                  sx={{
                    p: 0,
                    "& .MuiSvgIcon-root": {
                      fontSize: 16,
                      marginRight: "5px",
                    },
                  }}
                />
              }
              label="Yes"
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "12px",
                  color: "#1E1E1E",
                },
              }}
            />
          </RadioGroup>
        </FormControl>
      )}
    </Box>
  );
};

export default SecondaryInsurance;
